import { render } from "./Component005.vue?vue&type=template&id=455f80bb"
import script from "./Component005.vue?vue&type=script&lang=js"
export * from "./Component005.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\z4613\\Downloads\\461374167.github.io-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__